<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - Lieferung</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--confirmation">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <content-toggle toggle="Lieferung" isToggled="true">
                                <div class="row">
                                    <div class="col col-6">
                                        <card>
                                            <card-content>
                                                <description-group grid="true">
                                                    <description-element title="errechneter K-Liefertermin"
                                                                         :caption="askForQuote?.client_order?.delivery_at"
                                                                         is-date="true"/>
                                                    <description-element title="korrigierter K-Liefertermin"
                                                                         :caption="askForQuote?.client_late_delivery?.new_delivery_date"
                                                                         is-date="true"
                                                                         :icon="hasClientOrder ? 'calendar-31' : null"
                                                                         @click="hasClientOrder ? clientLateDeliveryModal = true : false;" :style="{ cursor: hasClientOrder ? 'pointer' : '' }" />
                                                </description-group>
                                            </card-content>
                                            <client-late-delivery-modal v-if="clientLateDeliveryModal"
                                                                        :ask-for-quote="askForQuote"
                                                                        @closeDialog="clientLateDeliveryModal = false;"/>
                                        </card>

                                        <outgoing-goods-client :ask-for-quote="askForQuote" :admin-users="adminUsers"/>
                                    </div>
                                    <div class="col col-6">
                                        <card>
                                            <card-content>
                                                <description-group grid="true">
                                                    <description-element title="P-Liefertermin lt Bestellung"
                                                                         :caption="askForQuote?.producer_order?.delivery_date"
                                                                         is-date="true"/>
                                                    <description-element title="aktueller P-Liefertermin"
                                                                         :caption="askForQuote?.producer_order?.delivery_date_corrected ? askForQuote?.producer_order?.delivery_date_corrected : askForQuote?.producer_order?.delivery_date"
                                                                         is-date="true"
                                                                         :icon="hasClientOrder ? 'calendar-31' : null"
                                                                         @click="askForQuote?.producer_order ? producerLateDeliveryDirectModal = true : false;" :style="{ cursor: askForQuote?.producer_order ? 'pointer' : '' }"/>
                                                </description-group>
                                                <producer-late-delivery-direct-modal
                                                    v-if="producerLateDeliveryDirectModal" :ask-for-quote="askForQuote"
                                                    @closeDialog="producerLateDeliveryDirectModal = false;"/>
                                            </card-content>
                                        </card>

                                        <incoming-goods-producer :ask-for-quote="askForQuote"/>

                                        <producer-late-deliveries :ask-for-quote="askForQuote"/>

                                        <producer-order-delivery-reminder :ask-for-quote="askForQuote"/>

                                    </div>
                                </div>
                            </content-toggle>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <content-toggle toggle="Reklamation">
                                <div class="row">
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Kundenreklamation</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--card table--stripped">
                                                    <thead>
                                                    <tr>
                                                        <th>Eingangsdatum</th>
                                                        <th>Menge</th>
                                                        <th>Grund</th>
                                                        <th>Kommentar</th>
                                                        <th>berechtigt</th>
                                                        <th>Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="clientComplaint in clientComplaintTable"
                                                        :key="clientComplaint.index">
                                                        <td>{{ clientComplaint.complaint_at_string }}</td>
                                                        <td>{{ clientComplaint.amount }}</td>
                                                        <td>{{ clientComplaint.complaint_reason_string }}</td>
                                                        <td>{{ clientComplaint.comment }}</td>
                                                        <td>{{ clientComplaint.reason_valid_string }}</td>
                                                        <td>{{ clientComplaint.closed_string }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </card-content>
                                        </card>

                                        <incoming-goods-client :ask-for-quote="askForQuote" :admin-users="adminUsers"/>

                                    </div>
                                    <div class="col col-6">
                                        <card>
                                            <card-header>
                                                <card-overline>Produzenzenreklamation</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--card table--stripped">
                                                    <thead>
                                                    <tr>
                                                        <th>Ausgangsdatum</th>
                                                        <th>Menge</th>
                                                        <th>Grund</th>
                                                        <th>Kommentar</th>
                                                        <th>berechtigt</th>
                                                        <th>Status</th>
                                                        <th>Wiedervorlage</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="producerComplaint in producerComplaintTable"
                                                        :key="producerComplaint.index">
                                                        <td>{{ producerComplaint.complaint_at_string }}</td>
                                                        <td>{{ producerComplaint.amount }}</td>
                                                        <td>{{ producerComplaint.complaint_reason_string }}</td>
                                                        <td>{{ producerComplaint.comment }}</td>
                                                        <td>{{ producerComplaint.reason_valid_string }}</td>
                                                        <td>{{ producerComplaint.closed_string }}</td>
                                                        <td>{10.10.2022}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </card-content>
                                        </card>

                                        <outgoing-goods-producer :ask-for-quote="askForQuote" :admin-users="adminUsers" />

                                    </div>
                                </div>
                            </content-toggle>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import ContentToggle from '@partfactory/Shared/Elements/ContentToggle';
import ProducerOrderDeliveryReminder from '@partfactory/Pages/Admin/AskForQuote/Delivery/ProducerOrderDeliveryReminder';
import OutgoingGoodsClient from '@partfactory/Pages/Admin/AskForQuote/Delivery/OutgoingGoodsClient';
import IncomingGoodsProducer from '@partfactory/Pages/Admin/AskForQuote/Delivery/IncomingGoodsProducer';
import ProducerLateDeliveries from '@partfactory/Pages/Admin/AskForQuote/Delivery/ProducerLateDeliveries';
import ClientLateDeliveryModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ClientLateDeliveryModal';
import ProducerLateDeliveryDirectModal
    from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerLateDeliveryDirectModal';
import IncomingGoodsClient from '@partfactory/Pages/Admin/AskForQuote/Delivery/IncomingGoodsClient';
import OutgoingGoodsProducer from '@partfactory/Pages/Admin/AskForQuote/Delivery/OutgoingGoodsProducer';

export default {
    name: 'Delivery',
    components: {
        OutgoingGoodsProducer,
        IncomingGoodsClient,
        ProducerLateDeliveryDirectModal,
        ClientLateDeliveryModal,
        ProducerLateDeliveries,
        IncomingGoodsProducer,
        OutgoingGoodsClient,
        ProducerOrderDeliveryReminder,
        ContentToggle,
        DescriptionElement,
        DescriptionGroup, CardContent, CardOverline, CardHeader, Card, AskForQuoteHeader, AppAdminLayout
    },
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            clientLateDeliveryModal: false,
            producerLateDeliveryDirectModal: false,
        };
    },
    computed: {
        clientComplaintTable() {
            let clientComplaints = this.askForQuote?.client_complaints;
            clientComplaints?.forEach(clientComplaint => {
                clientComplaint.complaint_at_string = this.$date(clientComplaint.complaint_at);
                clientComplaint.complaint_reason_string = this.$readableComplaintReason(clientComplaint.complaint_reason_id);
                clientComplaint.creator_string = clientComplaint.creator === 1 ? 'Partfactory' : 'Kunde';
                clientComplaint.reason_valid_string = clientComplaint.reason_valid === -1 ? 'Offen' : clientComplaint.reason_valid === 1 ? 'Ja' : 'Nein';
                clientComplaint.closed_string = clientComplaint.closed === 1 ? 'geschlossen' : 'offen';

                return clientComplaint;
            });
            return clientComplaints;
        },
        producerComplaintTable() {
            let producerComplaints = this.askForQuote?.producer_complaints;
            producerComplaints?.forEach(producerComplaint => {
                producerComplaint.complaint_at_string = this.$date(producerComplaint.complaint_at);
                producerComplaint.complaint_reason_string = this.$readableComplaintReason(producerComplaint.complaint_reason_id);
                producerComplaint.creator_string = producerComplaint.creator === 1 ? 'Partfactory' : 'Kunde';
                producerComplaint.reason_valid_string = producerComplaint.reason_valid === -1 ? 'Offen' : producerComplaint.reason_valid === 1 ? 'Ja' : 'Nein';
                producerComplaint.closed_string = producerComplaint.closed === 1 ? 'geschlossen' : 'offen';

                return producerComplaint;
            });
            return producerComplaints;
        },
        hasClientOrder() {
            return !!this.askForQuote.client_order;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
    },
    methods: {},
};
</script>
